/**
 * Simulation, rendering, and networking constants shared by client and server.
 *
 * Anything that affects gameplay balance or wire-format compatibility belongs
 * here, not in either package's local code, so that the two sides can never
 * silently disagree. Values are intentionally conservative for milestone 1
 * and will be tuned by the calibration tests added in milestone 2.
 */

/** Newton's gravitational constant, m^3 / (kg * s^2). */
export const G = 6.6743e-11;

/** Authoritative server simulation tick rate, in Hz. */
export const SERVER_TICK_HZ = 30;

/** Client render-time prediction tick rate, in Hz. */
export const CLIENT_PREDICT_HZ = 60;

/** Snapshot broadcast cadence, expressed in server ticks per snapshot. */
export const SNAPSHOT_EVERY_N_TICKS = 3;

/** Hard cap on players per room (and therefore per planetary system). */
export const MAX_PLAYERS_PER_ROOM = 16;

/** Render-time scale: world meters multiplied by this become Three.js units. */
export const WORLD_SCALE = 1 / 1_000_000;

/** Wire-protocol version. Increment on any breaking message-format change. */
export const PROTOCOL_VERSION = 1 as const;
